<style lang="less" scoped>
  #login {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #fafafa;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .container {
    width: 360px;
    border: solid .5px #d9dde8;
    border-radius: 2px;
    background-color: #fff;
    align-items: center;
    padding: 54px 16px 16px 16px;
    .login-form {
      margin-bottom: 16px;

      .form__input {
        margin-bottom: 16px;
      }
      .form__btn {
        width: 100%;
        text-align: center;
      }
    }
    .register-link {
      width: 100%;
      height: 40px;
      color: #7ed321;
      text-align: center;
      display: inline-block;
      margin: auto;
      line-height: 40px;
    }
  }
  .logo {
    text-align: center;
    margin-bottom: 44px;
    > img {
      width: 197px;
    }
  }

  @media screen and (max-width: 560px) {
    #login {
      background: white;
    }
    .container {
      width: 100%;
      border: none;
    }
  }
</style>

<template lang="pug">
  #login
    .container
      .logo
        img(src="@/assets/happytree-mobile@2x.png")
      form.login-form(@submit.prevent="login")
        el-input.form__input(type="email", v-model="email", placeholder="아이디")
        el-input.form__input(type="password", v-model="password", placeholder="비밀번호")
        el-button.form__btn(type="success", native-type="submit") 로그인
      router-link(to="/register")
        .register-link 회원가입
</template>

<script>
export default {
  data() {
    return {
      email: null,
      password: null,
    };
  },
  methods: {
    async login() {
      try {
        const payload = {
          email: this.email,
          password: this.password,
        };
        if (!this.email || !this.password) {
          alert('누락된 정보가 있습니다.');
          return false;
        }
        const { data } = await this.$http.post('/login', payload);
        // 로그인 성공
        this.$localStorage.remove('admin-token');
        this.$localStorage.set('token', data.token);
        this.$http.defaults.headers.common.Authorization = `Bearer ${data.token}`;
        this.$router.push('/');
      } catch (e) {
        const msg = e.response.data.message;
        alert(msg);
      }
      return true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/login.vue